export const PORTRAIT_MOBILE_MAX_WIDTH_FALLBACK = 768;
export const PORTRAIT_TABLET_MAX_WIDTH_FALLBACK = 1024;

export const LANDSCAPE_MOBILE_MAX_WIDTH_FALLBACK = 900;
export const LANDSCAPE_TABLET_MAX_WIDTH_FALLBACK = 1279;
